import { jsx as C } from "react/jsx-runtime";
const t = ({ size: L }) => {
  switch (L) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M3.33501 12.6683H4.17601L11.0003 5.84396L10.1593 5.00296L3.33501 11.8273V12.6683ZM2.33501 13.6683V11.412L11.1287 2.62213C11.2295 2.53057 11.3407 2.45985 11.4625 2.40996C11.5844 2.35996 11.7122 2.33496 11.8458 2.33496C11.9795 2.33496 12.109 2.35868 12.2342 2.40613C12.3595 2.45357 12.4705 2.52902 12.567 2.63246L13.3812 3.45679C13.4846 3.55335 13.5583 3.66446 13.6023 3.79013C13.6463 3.91579 13.6683 4.04146 13.6683 4.16713C13.6683 4.30124 13.6455 4.42918 13.5997 4.55096C13.5539 4.67285 13.4811 4.78418 13.3812 4.88496L4.59134 13.6683H2.33501ZM10.5725 5.43079L10.1593 5.00296L11.0003 5.84396L10.5725 5.43079Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M5 19H6.2615L16.498 8.7635L15.2365 7.502L5 17.7385V19ZM3.5 20.5V17.1155L16.6905 3.93075C16.8417 3.79342 17.0086 3.68733 17.1913 3.6125C17.3741 3.5375 17.5658 3.5 17.7663 3.5C17.9668 3.5 18.1609 3.53558 18.3488 3.60675C18.5368 3.67792 18.7032 3.79108 18.848 3.94625L20.0693 5.18275C20.2244 5.32758 20.335 5.49425 20.401 5.68275C20.467 5.87125 20.5 6.05975 20.5 6.24825C20.5 6.44942 20.4657 6.64133 20.397 6.824C20.3283 7.00683 20.2191 7.17383 20.0693 7.325L6.8845 20.5H3.5ZM15.8562 8.14375L15.2365 7.502L16.498 8.7635L15.8562 8.14375Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M4.16832 15.8317H5.21957L13.75 7.30129L12.6987 6.25004L4.16832 14.7805V15.8317ZM2.91832 17.0817V14.2613L13.9104 3.274C14.0364 3.15955 14.1755 3.07115 14.3277 3.00879C14.4801 2.94629 14.6398 2.91504 14.8069 2.91504C14.9739 2.91504 15.1358 2.94469 15.2923 3.004C15.4489 3.0633 15.5876 3.15761 15.7083 3.28691L16.726 4.31733C16.8553 4.43803 16.9475 4.57691 17.0025 4.734C17.0575 4.89108 17.085 5.04816 17.085 5.20525C17.085 5.37289 17.0564 5.53282 16.9992 5.68504C16.9419 5.8374 16.8509 5.97657 16.726 6.10254L5.73874 17.0817H2.91832ZM13.2152 6.78483L12.6987 6.25004L13.75 7.30129L13.2152 6.78483Z",
          fill: "currentColor"
        }
      );
  }
}, e = ({ size: L }) => {
  switch (L) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M3.37267 12.6193H4.32667L10.5723 6.37366L9.62633 5.42366L3.37267 11.6773V12.6193ZM1.86 14.136V11.0477L10.652 2.26832C10.7907 2.1381 10.9446 2.03832 11.1137 1.96899C11.2827 1.89966 11.4601 1.86499 11.6458 1.86499C11.8289 1.86499 12.0078 1.89966 12.1825 1.96899C12.3571 2.03832 12.5108 2.14232 12.6437 2.28099L13.7317 3.37366C13.8703 3.50388 13.9722 3.65699 14.0373 3.83299C14.1024 4.00888 14.135 4.18549 14.135 4.36282C14.135 4.5486 14.1024 4.72666 14.0373 4.89699C13.9722 5.06743 13.8703 5.22199 13.7317 5.36066L4.95633 14.136H1.86ZM10.093 5.90299L9.62633 5.42366L10.5723 6.37366L10.093 5.90299Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M5.06275 18.9264H6.49375L15.8622 9.55792L14.4432 8.13292L5.06275 17.5134V18.9264ZM2.79375 21.2014V16.5689L15.9817 3.39992C16.1897 3.20459 16.4206 3.05492 16.6742 2.95092C16.9277 2.84692 17.1938 2.79492 17.4725 2.79492C17.7472 2.79492 18.0155 2.84692 18.2775 2.95092C18.5393 3.05492 18.7699 3.21092 18.9692 3.41892L20.6012 5.05792C20.8092 5.25326 20.9621 5.48292 21.0597 5.74692C21.1574 6.01076 21.2062 6.27567 21.2062 6.54167C21.2062 6.82034 21.1574 7.08742 21.0597 7.34292C20.9621 7.59859 20.8092 7.83042 20.6012 8.03842L7.43825 21.2014H2.79375ZM15.1432 8.85192L14.4432 8.13292L15.8622 9.55792L15.1432 8.85192Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M4.21583 15.773H5.40833L13.2154 7.96591L12.0329 6.77841L4.21583 14.5955V15.773ZM2.325 17.6688V13.8084L13.315 2.83425C13.4883 2.67147 13.6807 2.54674 13.8921 2.46008C14.1033 2.37341 14.3251 2.33008 14.5573 2.33008C14.7862 2.33008 15.0098 2.37341 15.2281 2.46008C15.4463 2.54674 15.6385 2.67675 15.8046 2.85008L17.1646 4.21591C17.3379 4.37869 17.4653 4.57008 17.5467 4.79008C17.6281 5.00994 17.6687 5.2307 17.6687 5.45237C17.6687 5.68459 17.6281 5.90716 17.5467 6.12008C17.4653 6.33313 17.3379 6.52633 17.1646 6.69966L6.19541 17.6688H2.325ZM12.6162 7.37758L12.0329 6.77841L13.2154 7.96591L12.6162 7.37758Z",
          fill: "currentColor"
        }
      );
  }
}, o = ({
  size: L = "md",
  weight: r = "default"
}) => {
  switch (r) {
    case "bold":
      return /* @__PURE__ */ C(e, { size: L });
    case "book":
    case "default":
      return /* @__PURE__ */ C(t, { size: L });
  }
};
export {
  o as default
};
//# sourceMappingURL=DIconEdit.js.map
